module.exports = __webpack_public_path__ + "img/company-tt.c611a210.png";